
import mixin from "./mixin";
import notifications from "../../../lib/notifications";
import SearchFilterEditor from "../SearchFilterEditor.vue";
import { Component, Mixins } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { FacilityModule, SystemModule } from "@/store/modules/index";
import * as modals from "@/lib/modals";

@Component({
  name: modals.manageFacilitySavedSearchesModal,
  components: { SearchFilterEditor }
})
export default class ManageFacilitySavedSearchesModal extends Mixins(mixin) {
  facilityModule: FacilityModule = getModule(FacilityModule);
  systemModule: SystemModule = getModule(SystemModule);
  showFacility: boolean = true;
  selectedFilter: any = null;
  isSaving: boolean = false;
  detailView: boolean = false;
  facilityFilter: string = null;
  defaultFacility: string = null;
  filterKey: number = 0;
  
  get facilities() {
    return this.systemModule.facilities;
  }

  get showDetail() {
    return this.detailView;
  }

  get filters() {
    return this.facilityModule.facilityOrderSearches;
  }

  get currentFilters() {
    if (this.facilityFilter) {
      return this.filters.filter(x => x.facilityCode == this.facilityFilter);
    } else {
      return this.filters;
    }
  }

  load() {
    if (this.facilities && this.facilities.length == 1) {
      this.defaultFacility = this.facilities[0].facilityCode;
      this.showFacility = false;
    }
  }
  async save(filter) {
    let payload = {
      id: filter.id,
      facilityCode: filter.facilityCode,
      searchName: filter.searchName,
      searchFields: filter.searchFields.map(sf=>{
        if(sf.name == 'RefNumbers'){
            return {
              name:'RefNumbers',
              dataType:sf.dataType,
              filterValues:sf.filterValues.map(fv=>JSON.stringify(fv))
            }
        }
        return sf
      })
    };

    this.isSaving = true;

    try {
      await this.facilityModule.saveFacilityOrderSearch(payload);
    } catch (ex) {
      this.isSaving = false;
      notifications.error("Save Search", "Failed to save search", ex);
      return;
    }

    try {
      await this.facilityModule.getFacilitySavedOrderSearches();
      this.showList();
    } catch (ex) {
      notifications.error("Save Search", "Failed to load existing searches.", ex);
    }

    this.isSaving = false;
  }
  addFilter() {
    this.selectedFilter = {
      searchName: null,
      facilityCode: this.defaultFacility,
      searchFields: []
    };
    this.detailView = true;
  }
  showList() {
    this.selectedFilter = { searchFields: [] };
    this.detailView = false;
  }
  edit(filter) {
    this.selectedFilter = JSON.parse(JSON.stringify(filter));
    this.detailView = true;
  }
  hide() {
    this.selectedFilter = { searchFields: [] };
    this.detailView = false;
    this.$emit("input", false);
  }
  deleteFilter(filter) {
    this.$bvModal
      .msgBoxConfirm(
        `Are you sure you want to remove the filter '[${filter.facilityCode}] ${filter.searchName}'?`
      )
      .then(value => {
        if (value) this.facilityModule.deleteFacilityOrderSearch(filter.id);
      })
      .catch(err => {
        console.error(err);
      });
  }
}
